/**
 * Created by Jan Bradac on 3.8.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.ActionHandlers;

    (function (ActionHandlers, $, undefined) {
        /**
         * @memberOf Lfl.ActionHandlers
         */
        Lfl.ActionHandlers.OnDragHandlers;

        (function (OnDragHandlers, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.ActionHandlers.OnDragHandlers, 'ModalOdh')) {
                return;
            }


            /*
             |===========================================================================================================
             | Class definition
             |===========================================================================================================
             */

            /**
             * A handler that on element drag opens a modal that requires user confirmation that they really want to drag
             * the element and perform the action associated with it. See the PHP counterpart class for more info.
             *
             * @param {jQuery} $modal
             * @param {Lfl.ActionHandlers.OnDragHandlers.ModalOdhButtonDescriptor[]} buttonDescriptors
             * @param {Lfl.ActionHandlers.OnDragHandlers.DragHandlingParameters}  [handlingParameters]
             *
             * @memberOf Lfl.ActionHandlers.OnDragHandlers
             * @lends Lfl.ActionHandlers.OnDragHandlers.ModalOdh
             * @constructor
             */
            Lfl.ActionHandlers.OnDragHandlers.ModalOdh = function ($modal, buttonDescriptors, handlingParameters) {
                /*
                 |-------------------------------------------------------------------------------------------------------------------
                 | Construction
                 |-------------------------------------------------------------------------------------------------------------------
                 */
                
                if (typeof handlingParameters === 'undefined') {
                    handlingParameters = new Lfl.ActionHandlers.OnDragHandlers.DragHandlingParameters();
                }

                var rememberConfirmation = true;
                var confirmed = false;
                /**
                 * A set of client parameters provided when the odh was confirmed.
                 * @type {{}}
                 */
                var confirmationClientParameters = {};
                var closedViaButton;

                /**
                 * The function to call when the result of this handler is resolved.
                 * @type {function}
                 */
                var completionCallback;
                /**
                 * The id which identifies this odh.
                 * @type {int}
                 */
                var completionId;
                /**
                 * A crate containing parameters for the drag handlers and return parameters from the ODHs.
                 * @type {Lfl.Tiem.Core.TiemOdhDataCrate}
                 */
                var dataCrate;

                // Note: the handler is not bound to any one specific $element (it is passed to methods as a parameter
                // each time) which allows for a shared handler for multiple elements. "Confirm once for multiple
                // elements" can be achieved this way.

                /*
                 |-------------------------------------------------------------------------
                 | Register callbacks */
                var odh = this;

                _.each(buttonDescriptors,
                    function (/** Lfl.ActionHandlers.OnDragHandlers.ModalOdhButtonDescriptor */descriptor,
                              key) {
                        descriptor.init(odh);
                    });

                // Register the deny on modal close callback
                $modal.on('hidden.bs.modal', function (e) {
                    // Only call deny if the dialogue was not confirmed already by pressing the confirm button.
                    // And we know for sure that in such case the confirm will be called earlier, because the
                    // button has to be clicked first to actually then trigger the closing of the dialog.
                    if (closedViaButton !== true) {
                        odh.deny({
                            modalCanceled: true
                        });
                    }

                    // Reset the attribute.
                    closedViaButton = false;
                });

                // The deny callback on modal close is registered when the modal is opened.

                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Public methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

                this.registerFor = function ($element) {
                    // We delegate the call to the managing class.
                    Lfl.ActionHandlers.OnDragHandlers.OnDragHandlersManager.register($element, this);
                };

                /**
                 * Note: We receive the $element as a parameter each time, which allows for a shared handler for multiple elements -
                 */
                this.onStart = function ($element, event) {
                    // We allow the drag to proceed - let the user finish the movement, so that we don't break their
                    // train of thoughts.
                    return true;
                };


                /**
                 * Note: We receive the $element as a parameter each time, which allows for a shared handler for multiple
                 * elements
                 * @param $element
                 * @param event
                 * @param {int} id The id assigned to this odh.
                 * @param {function} theCompletionCallback The function to call when the result of this handler is resolved.
                 * @param {Lfl.Tiem.Core.TiemOdhDataCrate} theDataCrate
                 * @returns {boolean}
                 */
                this.onStop = function ($element, event, id, theCompletionCallback, theDataCrate) {
                    // TODO - fix potential bugs - if called multiple times before being confirmed
                    // Fix: create eventId from event instance. Store the id and callback in callbacks array of objects
                    // indexed by eventId. Call all of those in confirm/deny.

                    completionCallback = theCompletionCallback;
                    completionId = id;
                    dataCrate = theDataCrate;

                    if(false === appliesToThisDrag(theDataCrate)) {
                        // This handler should not handle this drag so the drag is allowed.

                        // We send back empty parameters, because the confirmationClientParameters only apply if the
                        // drag was handled by this handler. In this case it was not so the parameters should be
                        // irrelevant.
                        handleCompletion({}, true);
                    } else if (rememberConfirmation !== true || confirmed !== true) {
                        Lfl.Modals.Displayer.displayBootstrapModal($modal);
                    } else {
                        handleCompletion(confirmationClientParameters, true);
                    }
                };

                /* 
                 |-------------------------------------------------------------------------
                 | Button press callbacks */

                /**
                 * Confirms the drag.
                 * @param {{}} dragSavingData
                 */
                this.confirm = function (dragSavingData) {
                    if (rememberConfirmation === true) {
                        confirmed = true;
                        confirmationClientParameters = dragSavingData;
                    }

                    closedViaButton = true;
                    handleCompletion(dragSavingData, true);
                };

                /**
                 * Cancels the drag because the user has denied it.
                 * @param {{}} dragSavingData
                 */
                this.deny = function (dragSavingData) {
                    if (rememberConfirmation === true) {
                        confirmed = false;
                        confirmationClientParameters = dragSavingData;
                    }

                    closedViaButton = true;
                    handleCompletion(dragSavingData, false);
                };

                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Private methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

                function handleCompletion(clientParameters, wasConfirmed) {
                    _.each(clientParameters, function (value, key) {
                        dataCrate.addClientParameter(key, value);
                    });
                    completionCallback(completionId, wasConfirmed);
                }

                /**
                 * Determines whether this handler should handle this drag.
                 * @param {Lfl.Tiem.Core.TiemOdhDataCrate} theDataCrate
                 * @return boolean
                 */
                function appliesToThisDrag(theDataCrate) {
                    if(theDataCrate.getDragInfo().horizontalDistance !== 0
                        && (handlingParameters.getAppliesToAxis() === 'x' || handlingParameters.getAppliesToAxis() === 'both')) {
                        return true;
                    }

                    if(theDataCrate.getDragInfo().verticalDistance !== 0
                        && (handlingParameters.getAppliesToAxis() === 'y' || handlingParameters.getAppliesToAxis() === 'both')) {
                        return true;
                    }

                    return false;
                }
            };
        }(ActionHandlers.OnDragHandlers = ActionHandlers.OnDragHandlers || {}, jQuery));
    }(Lfl.ActionHandlers = Lfl.ActionHandlers || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));

